import api from "../config/api/axiosConfig";

export const useDailyMenuRecipeApi = () => {
  const deleteDailyMenuRecipe = async (
    dailyMenuId: number,
    recipeId: number,
  ) => {
    const response = await api.delete(
      `/DailyMenuRecipe/${dailyMenuId}/${recipeId}`,
    );
    return response;
  };
  return {
    deleteDailyMenuRecipe,
  };
};
